module.exports = __webpack_public_path__ + "media/message.e98df8a4.mp3";